declare var pglob : IPhotometerGlobalVar;

module partner {
  'use strict';

  export class PartnerFlagCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      '$http', 
      '$window',
      '$element',
      '$timeout',
      '$q',
      'partnerService',
      'pageMetaService',
      'parallaxService',
    ];

    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope: IPartnerFlagScope,
      private $http: ng.IHttpService,
      private $window: ng.IWindowService,
      private $element: ng.IRootElementService,
      private $timeout : ng.ITimeoutService,
      private $q : ng.IQService,
      private partnerService : PartnerService,
      private pageMetaService: navigation.IPageMetaService,
      private parallaxService: navigation.IParallaxService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;

      $scope.googleMapsUrlWithKey = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAF1xLcjeFHOKAXWqhsv1x6cc7tIVtDlzU" //Api Key Managable from Google Cloud Console with admin@photometer.com

      var postLoad : () => void = function() {
        var currentCountry = $scope.vendordata.Countries.filter(function(val:Country, index: number) :boolean {
          return val.Code == $scope.vendordata.LocationCountryCode;
        });
        $scope.selectedCountry = currentCountry[0]; //country of the visitor or null if not found
        $scope.vm.onCountryChange();
      };
            
      partnerService.getPartnerData().then(function (data: VendorResult) {
        $scope.vendordata = data;
        postLoad();
      });

      
      this.parallaxService.subscribeOnScroll($scope, (e: ng.IAngularEvent, scrollTop : number) =>  {
        var el = partnerService.getPartnerCtrlElement();
        if (!el) return;
        var r : number = (scrollTop - ($(el).offset().top - 800));
        r = this.parallaxService.easeInOutQuad(r, 0, 59, 400);
        $($element).css({ "transform" : "translate3d(" + r + "px, 0, 0)" });
        $($element).removeClass("active");
      });


    }

    loadCountries() { 
      return this.$timeout(() => {
        if (!(this.$scope.Countries)) this.$scope.Countries = this.$scope.vendordata.Countries;
      }, 200);
    }

    onCountryChange() {
      this.$scope.selectedArea = null;
      this.$scope.selectedVendor = null;
      this.$scope.googleMapsQuery = null;

      var c = this.$scope.selectedCountry;
      if (c && this.getAreaData(c)) {
        if (c && this.getAreaData(c).Vendors) this.$scope.selectedVendor = this.selectVendorForCurrentBusinessArea(this.getAreaData(c));
        if (c && this.getAreaData(c).Areas) this.$scope.selectedArea = this.getAreaData(c).Areas[0];
      }
      if (this.$scope.selectedArea && this.$scope.selectedArea.Vendors) this.$scope.selectedVendor = this.$scope.selectedArea.Vendors[0];

      this.getOrUpdateLocation();
    }

    getOrUpdateLocation(): any {
      var v = this.getSelectedVendor();
      if (v) {
        this.partnerService.getPartnerLocation(v).then((latlong) => {
          if (v.Location) {
            this.$scope.googleMapsQuery = v.Location.lat + "," + v.Location.lng; 
          } else {
            this.$scope.googleMapsQuery = null;
          }
        });
      }
    }

    onAreaChange() {
      this.$scope.selectedVendor = this.selectVendorForCurrentBusinessArea(this.$scope.selectedArea);
    }

    selectVendorForCurrentBusinessArea(a : AreaData | Area) : VendorWBusinessArea {
      var def = a.Vendors[0];
      if (a.Vendors.length < 2) return def; //der einzige

      var rpm : IRouteParameter  = this.pageMetaService.searchRouteParameter("BusinessArea");
      if (!rpm) return def;

      var currentBusinessAreaId = rpm.Id;

      //a.Vendors[1].BusinessAreasList[0].ID
      var vArr = a.Vendors.filter((v, i) : boolean => {
        return v.BusinessAreasList.filter((ba, j) : boolean => {
          return ba.ID == currentBusinessAreaId;
        }).length > 0;
      });
      if (vArr.length > 0) return vArr[0]; 
      return def;
    }
    
    getAreaData(c : Country) : AreaData {
      if (!c) return null;
      return this.$scope.vendordata.AreaData[c.ID];
    }

    getSelectedVendor() {
      if (this.$scope.selectedCountry && this.$scope.selectedCountry.VendorId) return this.$scope.vendordata.Vendors[this.$scope.selectedCountry.VendorId];
      if (this.$scope.selectedVendor && this.$scope.selectedVendor.VendorId) return this.$scope.vendordata.Vendors[this.$scope.selectedVendor.VendorId];
      if (this.$scope.vendordata) return this.$scope.vendordata.DefaultVendor;
      return undefined;
    }

    togglePullOut() {
      var active : boolean = !$('.contactflag').hasClass("active");

      var boxWidth : number = 0;
      if (active) {
        boxWidth = -1 * 323 ;
        $('.contactflag').addClass("active");
      } else {
        $('.contactflag').removeClass("active");
      }
      $('.contactflag').css({ transform: "translateX(" + boxWidth + "px)" });
    }

  
    
  }

}